$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");

  if (p == "product_group_account_plan" || p == "general_account_plan") {
    $(document).on("click", ".toggle-table-row", function () {
      let rowId = $(this).attr("data-id");
      let $row = $(`.vat-account-row-${rowId}`);

      if ($row.is(":visible")) {
        $row.animate({ opacity: 0, height: "toggle" }, 200);
      } else {
        $row.animate({ opacity: 1, height: "toggle" }, 200);
      }
    });

    $(document).on("change", ".general-account-description", function (e) {
      e.preventDefault();
      saveGeneralAccountPlan();
    });

    $(document).on("change", ".value-input", function (e) {
      e.preventDefault();

      saveGeneralAccountPlan();
    });

    $(document).on("change", ".vat-account-input", function (e) {
      e.preventDefault();
      const productGroupId = $(this).attr("data-product-group-id");
      const planId = $(this).attr("data-product-group-account-plan-vat-id");
      const valueList = [];

      $(
        `input[name="vat_account"][data-product-group-id="${productGroupId}"]`,
      ).each(function () {
        const curretnValue = $(this).val();

        if ($(this).attr("data-product-group-account-plan-vat-id") != planId) {
          valueList.push(curretnValue);
        }
      });

      savePeoductGroupAccountPlan();
    });

    $(document).on("change", ".counter-tips-account", function (e) {
      e.preventDefault();
      const id = $(this).attr("data-general-account-plan-id");
      const value = $(this).val() || 0;

      const accountPlans = [];

      accountPlans.push({
        general_account_plan_id: id,
        description: "",
        value: value,
      });

      $.ajax({
        type: "POST",
        url: "/api/v1/private/account-plan/update-general-account",
        data: { accountPlanData: accountPlans },
      })
        .done(function (data) {
          if (data.html) {
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 5000,
            });
          }
        });
    });

    function saveGeneralAccountPlan() {
      let accountPlanData = [];

      // Select input fields based on the visible view
      const descriptionInputs = $('input[name="general-account-description"]');

      descriptionInputs.each(function () {
        const id = $(this).attr("data-general-account-plan-id");
        const description = $(this).val();
        const valueInput = $(
          `input[name="general-account-value"][data-general-account-plan-id="${id}"]`,
        );

        const value = valueInput.val() || 0;

        // Add data to the array
        accountPlanData.push({
          general_account_plan_id: id,
          description: description,
          value: value,
        });
      });

      $.ajax({
        type: "POST",
        url: "/api/v1/private/account-plan/update-general-account",
        data: { accountPlanData },
      })
        .done(function (data) {
          if (data.html) {
            popupAlert();
            $("#general-account-plan-list-view").empty();
            $("#general-account-plan-list-view").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    $(document).on("click", "#retrieve-account-plans", function () {
      const button = $(this);
      const originalText = button.html();
      button.prop("disabled", true);
      button.html('<div class="loader"></div>');

      $("#retrieve-error-container").empty();
      $("#retrieve-error-container").css("margin-top", "0");

      $.ajax({
        type: "GET",
        url: "/api/v1/private/account-plan/retrieve",
      })
        .done(function (data) {
          if (data.html != null && data.html != undefined) {
            $("#general-account-plan-view").empty();
            $("#general-account-plan-view").html(data.html);
            $(".account-plan-selector").select2({
              theme: "bootstrap4",
              width: "100%",
            });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
            return;
          }
          const alertHtml = getAlertHtml(data.responseJSON.message, "danger");
          $("#retrieve-error-container").css("margin-top", "1rem");
          $("#retrieve-error-container").html(alertHtml);
        })
        .always(function () {
          button.html(originalText);
          button.prop("disabled", false);
        });
    });

    $(document).on("click", "#save-account-plan", function (event) {
      event.preventDefault();

      let valid = true;
      const errorContainer = $("#account-plan-error-container");
      errorContainer.html("");

      $(".account-plan-selector").each(function () {
        const select = $(this);
        if (select.val() === "") {
          valid = false;
          select.addClass("is-invalid");
        } else {
          select.removeClass("is-invalid");
        }
      });

      if (!valid) {
        let errorMessage = errorContainer.data("required-message");
        let alertHtml = getAlertHtml(errorMessage, "danger");
        errorContainer.html(alertHtml);
        return;
      }

      // If valid, submit the form
      $("#account-plan-form").submit();
    });

    $(document).on("change", ".account-plan-selector", function () {
      $(this).removeClass("is-invalid");
    });

    $(document).on("submit", "#account-plan-form", function (e) {
      e.preventDefault();

      let submitBtn = $("#save-account-plan");
      const originalText = submitBtn.html();
      submitBtn.prop("disabled", true);
      submitBtn.html('<div class="loader"></div>');

      const formData = $(this).serialize();
      $(".account-plan-selector").prop("disabled", true);
      $("#account-plan-error-container").empty();
      $.ajax({
        url: "/api/v1/private/account-plan/create-general-account-plan",
        method: "POST",
        data: formData,
      })
        .done(function (data) {
          if (data.html != undefined && data.html != null) {
            $("#general-account-plan-view .card-box").empty();
            const successHtml = getAlertHtml(data.message, "success");
            $("#general-account-plan-view .card-box").append(successHtml);

            setTimeout(function () {
              $("#general-account-plan-view").empty();
              $("#general-account-plan-view").html(data.html);
            }, 2000);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          const alertHtml = getAlertHtml(data.responseJSON.message, "danger");
          $("#account-plan-error-container").append(alertHtml);
        })
        .always(function () {
          submitBtn.html(originalText);
          submitBtn.prop("disabled", false);
          $(".account-plan-selector").prop("disabled", false);
        });
    });

    function savePeoductGroupAccountPlan() {
      var vatAccounts = [];
      var vatAccountGroups = {};

      // Collect VAT accounts grouped by product group ID
      $(".vat-account-input").each(function () {
        var groupId = $(this).closest("tr").attr("data-product-group-id");
        var groupName = $(this).closest("tr").attr("data-product-group-name");

        var vatAccountData = {
          product_group_account_plan_vat_id: $(this).attr(
            "data-product-group-account-plan-vat-id",
          ),
          vat_account: $(this).val(),
        };

        // Initialize group if it doesn't exist
        if (!vatAccountGroups[groupId]) {
          vatAccountGroups[groupId] = { groupName: groupName, accounts: [] };
        }

        vatAccountGroups[groupId].accounts.push(vatAccountData.vat_account);
        vatAccounts.push(vatAccountData);
      });

      $.ajax({
        type: "POST",
        url: "/api/v1/private/account-plan/update-product-group-account",
        data: { vatAccounts },
      })
        .done(function (data) {
          if (data.html) {
            popupAlert();
            $("#product-group-account-plan-list-view").empty();
            $("#product-group-account-plan-list-view").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
